module.exports = __webpack_public_path__ + "static/media/dtj-mockup-1.820e67c8.jpg";